import { render, staticRenderFns } from "./tab-view.vue?vue&type=template&id=5a5c29ab&scoped=true&"
import script from "./tab-view.vue?vue&type=script&lang=js&"
export * from "./tab-view.vue?vue&type=script&lang=js&"
import style0 from "./tab-view.vue?vue&type=style&index=0&id=5a5c29ab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5c29ab",
  null
  
)

export default component.exports